import React, { ChangeEvent, FC, useState } from 'react';
import styled from 'styled-components';
import { Trans, useTranslation } from 'react-i18next';
import { RadioButtonGroup, RadioButton, Checkbox } from '@code/innovance-react-ui-kit';

import {
  Container,
  InfoColumn,
  InfoLabel,
  InfoRow,
  Separator,
  Title,
} from 'src/front/components/FormStyles';
import { useProblemTrackingSystemState } from 'src/front/contexts/ProblemTrackingSystemContext';

import NewRecord from './NewRecord';
import ViewRecords from './ViewRecords';

enum OPERATION_TYPE {
  NEW_RECORD = 'NEW_RECORD',
  VIEW_RECORDS = 'VIEW_RECORDS',
}

const CheckboxContainer = styled.div`
  height: auto;
  margin-left: 10px;
  span {
    color: red;
  }
`;

const StyledInfoColumn = styled.div`
  display: flex;
  height: auto;
  flex-direction: row;
  align-items: center;
`;

interface Props {
  unregisteredPerson: boolean;
}

const Records: FC<Props> = ({ unregisteredPerson }) => {
  const { t } = useTranslation();
  const { customerSearchFormValues, customerSearchValues } = useProblemTrackingSystemState();

  const [selectedOperationType, setSelectedOperationType] = useState<string>('NEW_RECORD');

  const handleRadioButtonChange = async ({
    target,
  }: ChangeEvent<HTMLInputElement>): Promise<void> => {
    setSelectedOperationType(target.value);
  };

  return (
    <Container>
      <Title>
        <Trans i18nKey="problemTrackingSystem_title" />
      </Title>
      <Separator />
      <InfoRow>
        <StyledInfoColumn>
          <InfoLabel>
            <Trans i18nKey="general_components_clientName_text" />
          </InfoLabel>
          {unregisteredPerson
            ? `${customerSearchFormValues.customerName} ${customerSearchFormValues.customerSurname}`
            : `${customerSearchValues.clientName}`}
        </StyledInfoColumn>
        {unregisteredPerson ? (
          <InfoColumn>
            <CheckboxContainer>
              <Checkbox
                id="unregistered-person"
                label={t('problemTrackingSystem_unregisteredPerson_text')}
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                onChange={() => {}}
                value={unregisteredPerson}
                disabled
              />
            </CheckboxContainer>
          </InfoColumn>
        ) : null}
      </InfoRow>
      <Separator />
      <RadioButtonGroup onChange={handleRadioButtonChange} value={selectedOperationType}>
        <RadioButton
          label={t('problemTrackingSystem_newRecord_text')}
          name={OPERATION_TYPE.NEW_RECORD}
        />
        <RadioButton
          label={t('problemTrackingSystem_viewRecords_text')}
          name={OPERATION_TYPE.VIEW_RECORDS}
        />
      </RadioButtonGroup>
      <Separator />
      {selectedOperationType === OPERATION_TYPE.NEW_RECORD ? <NewRecord /> : <ViewRecords />}
    </Container>
  );
};

export default Records;
